module.exports = __webpack_public_path__ + "static/media/A.c73780b6.jpg";